// Dates are "YYYY-MM-DD" strings throughout this app (see AssignedDietPlansTable) —
// lexicographic comparison is safe for that format and avoids Date/timezone parsing.

/** Pick the plan (if any) covering `todayStr`, or the soonest upcoming one otherwise. */
export function resolvePlanStatus(plans, todayStr) {
  const dated = (plans || []).filter((p) => p?.start_date && p?.end_date);

  const activeCandidates = dated.filter(
    (p) => p.start_date <= todayStr && todayStr <= p.end_date
  );
  if (activeCandidates.length > 0) {
    const plan = activeCandidates.reduce((earliest, p) =>
      p.start_date < earliest.start_date ? p : earliest
    );
    return { status: 'active', plan };
  }

  const upcomingCandidates = dated.filter((p) => p.start_date > todayStr);
  if (upcomingCandidates.length > 0) {
    const plan = upcomingCandidates.reduce((soonest, p) =>
      p.start_date < soonest.start_date ? p : soonest
    );
    return { status: 'upcoming', plan };
  }

  return { status: 'none', plan: null };
}
